<template>
  <div class="match-block">
    <font-awesome-icon :icon="['fas','square-full']" class="has-text-success" size="xs"/>
    <font-awesome-icon :icon="['fas','square-full']" class="has-text-success" size="xs"/>
    <font-awesome-icon :icon="['fas','square-full']" class="has-text-success" size="xs"/>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSquareFull } from '@fortawesome/pro-solid-svg-icons';

library.add(faSquareFull);

export default {
};
</script>

<style lang="sass" scoped>
  @import "@/sass/custom.sass"

  .match-block
    margin-top: .25rem
    display: flex
    flex-direction: column
    justify-content: center
    height: 100%
    color: #28a745
    align-items: center
    & > *
      margin-bottom: .25rem
    &:last-child
      margin-bottom: none
</style>
